
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Seatercaronrentinmumbai() {



    const cardData =
    {
        keyword: '7 Seater Car On Rent in Mumbai',
        heading: 'Skyline Cabs: 7 Seater Car On Rent in Mumbai',
        headingDescription: '​Skyline Cabs offers comfortable and reliable 7 Seater Car on Rent in Mumbai services for all your group travel needs. Whether you are planning a family outing, corporate trip, or a special event, our well-maintained 7-seater vehicles and professional drivers ensure a smooth and enjoyable journey. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your 7-seater car rental with Skyline Cabs today and experience hassle-free group travel across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "7 Seater Car on Rent in Mumbai",
      "description": "Skyline Cabs offers 7-seater cars on rent in Mumbai, ideal for family trips, group travel, or comfortable long-distance journeys."
    },
    {
      "name": "Rent 7 Seater Car for Family Trip Mumbai",
      "description": "Planning a family getaway? Rent a spacious 7-seater car from Skyline Cabs in Mumbai for a comfortable and enjoyable ride."
    },
    {
      "name": "7 Seater Car Rental Mumbai",
      "description": "Get reliable 7-seater car rental services in Mumbai with Skyline Cabs. Perfect for group travel within the city or outstation."
    },
    {
      "name": "Mumbai 7 Seater Hire for Outstation",
      "description": "Heading out of Mumbai? Hire a 7-seater car from Skyline Cabs for outstation trips with ample space and comfort for all passengers."
    },
    {
      "name": "7 Seater Car Rental Booking Mumbai",
      "description": "Book your 7-seater rental car in Mumbai quickly and easily with Skyline Cabs. Flexible options and reliable service every time."
    }
  ],
  "tableData": [
    ["7 Seater Car on Rent in Mumbai", "Rent 7 Seater Car for Family Trip Mumbai"],
    ["7 Seater Car Rental Mumbai", "Mumbai 7 Seater Hire for Outstation"],
    ["7 Seater Car Rental Booking Mumbai"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "7-Seater Car on Rent in Mumbai",
      "WhyChoosedescription": "Rent a 7-seater car in Mumbai for your next family trip, group outing, or corporate event. Enjoy the extra space and comfort for both short city drives and long-distance journeys."
    },
    {
      "WhyChooseheading": "Perfect for Family and Group Travel",
      "WhyChoosedescription": "Our 7-seater cars offer spacious seating arrangements for families, friends, or business groups, ensuring a comfortable and enjoyable ride for all passengers."
    },
    {
      "WhyChooseheading": "Comfortable and Modern Interiors",
      "WhyChoosedescription": "Equipped with premium seating, air conditioning, and ample legroom, our 7-seater cars are designed to provide a smooth and comfortable ride for every passenger."
    },
    {
      "WhyChooseheading": "Ideal for City and Outstation Travel",
      "WhyChoosedescription": "Whether you're traveling within Mumbai or heading out of the city, our 7-seater cars are perfect for both short trips and long-distance journeys with ease and comfort."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our professional, courteous drivers are experienced with Mumbai roads, ensuring a safe, punctual, and comfortable ride to your destination."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "Each 7-seater car is thoroughly cleaned and sanitized after every trip to ensure hygiene and safety for your travel."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans and Packages",
      "WhyChoosedescription": "We offer hourly, daily, and multi-day rental options to suit your travel needs, giving you the flexibility to rent a 7-seater car for as long as you need."
    },
    {
      "WhyChooseheading": "24/7 Booking and Support",
      "WhyChoosedescription": "Book your 7-seater car at any time via our online platform or by calling our 24/7 customer support team, who are always ready to assist you with your booking needs."
    }
  ]
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a 7-seater car in Mumbai with Skyline Cabs?',
            answer:
                'Renting a 7-seater car in Mumbai is easy with Skyline Cabs. You can book through our website, mobile app, or by calling our customer support. Just provide your pickup location, travel date, and other trip details to get started.',
        },
        {
            id: 2,
            question: 'What types of 7-seater cars are available for rent in Mumbai?',
            answer:
                'We offer a variety of 7-seater cars, including the Toyota Innova Crysta, Kia Carens, and other SUVs. These vehicles are perfect for family trips, group outings, and corporate events.',
        },
        {
            id: 3,
            question: 'Is the 7-seater car suitable for long-distance travel?',
            answer:
                'Yes, our 7-seater cars are ideal for both short city trips and long-distance journeys. With spacious interiors, comfortable seating, and air conditioning, they provide a smooth and relaxing ride.',
        },
        {
            id: 4,
            question: 'Are the rental prices for 7-seater cars fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing for 7-seater car rentals. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and any applicable service fees. You will know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I rent a 7-seater car for hourly, half-day, or full-day use?',
            answer:
                'Yes, you can rent a 7-seater car for hourly, half-day, or full-day rentals. We provide flexible rental packages to suit your travel plans, whether it’s a short city trip or a full-day outstation journey.',
        },
        {
            id: 6,
            question: 'Is the 7-seater car air-conditioned and comfortable?',
            answer:
                'Yes, all of our 7-seater cars are air-conditioned, well-maintained, and equipped with comfortable seating, ensuring a pleasant journey for all passengers.',
        },
        {
            id: 7,
            question: 'Can I rent a 7-seater car for corporate or event travel?',
            answer:
                'Yes, our 7-seater cars are perfect for corporate transfers, events, group outings, or family trips. We provide professional drivers and excellent customer service for a smooth experience.',
        },
        {
            id: 8,
            question: 'What payment options are available for renting a 7-seater car?',
            answer:
                'We accept a variety of payment options including UPI, credit/debit cards, net banking, and cash. All online payments are secure and processed through trusted payment gateways.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my 7-seater car booking?',
            answer:
                'Yes, you can easily modify or cancel your 7-seater car booking via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for renting a 7-seater car in Mumbai?',
            answer:
                'Skyline Cabs offers comfortable, reliable, and affordable 7-seater car rentals in Mumbai. With well-maintained vehicles, professional drivers, and transparent pricing, we ensure a seamless and enjoyable travel experience.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sameer Mehta",
            rating: 5,
            review: "Rented a 7-seater for a family trip to Pune. The car was spacious, clean, and very comfortable. The driver was friendly and punctual, making our trip much more enjoyable. Highly recommend Skyline Cabs!"
        },
        {
            name: "Mrs. Kavita Jain",
            rating: 4,
            review: "Booked a 7-seater for a weekend getaway. The car was great, with enough space for everyone. The driver was courteous, but the only issue was that the AC could have been slightly colder. Overall, it was a good experience."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "7 Seater Car On Rent in Mumbai",
  "image": "https://skylinecabs.com/assets/images/7-seater-car-on-rent-mumbai.jpg",
  "description": "Book 7 seater car on rent in Mumbai with Skyline Cabs for group travel, family trips, airport transfers, and outstation journeys. Choose from spacious options like Ertiga, Kia Carens, and Innova Crysta with AC and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8842"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/7-seater-car-on-rent-in-mumbai"
  }
};



      
     
      

    return (
        <div>
<Helmet>
  <title>7 Seater Car On Rent in Mumbai | AC SUV & MPV Cabs | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book 7 seater car on rent in Mumbai with Skyline Cabs for group travel, family trips, airport transfers, and outstation journeys. Choose from spacious options like Ertiga, Kia Carens, and Innova Crysta with AC and experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="7 Seater Car On Rent in Mumbai, SUV Car Rental Mumbai, Ertiga Hire in Mumbai, Kia Carens Rental Mumbai, Innova Crysta 7 Seater Mumbai, Airport SUV Booking, Outstation 7 Seater Cab, AC MPV Car Hire Mumbai, Skyline Cabs Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/95.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Seatercaronrentinmumbai;